import base from './base.repository';
export default {
    ...base,
    getAllCities(){
        this.get('localization/cities');
        return this;
    }
}